/**
 * @generated SignedSource<<9c29df13403e0c47c47cd5f7bdccf6c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetOrgSettingsQuery$variables = {};
export type recoilGetOrgSettingsQuery$data = {
  readonly sys_organizations: ReadonlyArray<{
    readonly settings: any | null;
  }>;
};
export type recoilGetOrgSettingsQuery = {
  response: recoilGetOrgSettingsQuery$data;
  variables: recoilGetOrgSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      }
    ],
    "concreteType": "sys_organizations",
    "kind": "LinkedField",
    "name": "sys_organizations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settings",
        "storageKey": null
      }
    ],
    "storageKey": "sys_organizations(limit:1)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetOrgSettingsQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "recoilGetOrgSettingsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a0471b08f66adfe458f46ee6fe227796",
    "id": null,
    "metadata": {},
    "name": "recoilGetOrgSettingsQuery",
    "operationKind": "query",
    "text": "query recoilGetOrgSettingsQuery {\n  sys_organizations(limit: 1) {\n    settings\n  }\n}\n"
  }
};
})();

(node as any).hash = "6009195bba34f27b2652f57334759c55";

export default node;
